var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { Avatar } from '@mui/material';
import PrimaryToolTip from './PrimaryTooltip';
var ProfileCard = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: "lfc-flex lfc-gap-4 lfc-p-3  lfc-rounded-md ".concat((_a = props.containerClasses) !== null && _a !== void 0 ? _a : '') },
        React.createElement(Avatar, __assign({}, props.avatarProps)),
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-2 lfc-w-full lfc-line-clamp-1  lfc-truncate" }, props === null || props === void 0 ? void 0 :
            props.header,
            React.createElement(GBTypography, { variant: "body4", className: "lfc-truncate lfc-font-bold" }, (_b = props.name) !== null && _b !== void 0 ? _b : ''),
            React.createElement(PrimaryToolTip, { title: props.email, disableFocusListener: false, disableHoverListener: false, disableTouchListener: false, placement: "bottom" },
                React.createElement(GBTypography, { variant: "caption1", className: "lfc-truncate" }, (_c = props.email) !== null && _c !== void 0 ? _c : '')),
            React.createElement(GBTypography, { variant: "body4", className: "lfc-truncate lfc-font-bold" }, (_d = props.mobileNumber) !== null && _d !== void 0 ? _d : ''))));
};
export default ProfileCard;
//# sourceMappingURL=ProfileCard.js.map